// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eTD9","content":"styles_content__1gMx_"};